// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1312": "42783fcc","1378": "b8d9c1e6","1558": "eb9dc10b","2530": "e96a97f9","2703": "2b6e7ce0","5336": "5083bc52",}[chunkId] + ".css"
}